export default "__VITE_ASSET__aCSX$BDV__"